import 'babel-polyfill';
import 'intersection-observer';
import $ from 'jquery';

import './react';

// Only with webpack's require.context it is possible to require all files in a folder
// automatically, so we're using that instead of individual imports.
const context = require.context('./modules', false, /\.js$/);
const cached = {};

// Set module[filename] to the ES module exported by that file.
context.keys().forEach((key) => {
    // Transform './filename.js' to 'filename'
    const name = key.replace(/\.\/(.+?)\.js/, '$1');

    cached[name] = context(key);
});

// Run all modules once the DOM is ready.
$(document).ready(() => {
    Object.keys(cached).forEach((key) => {
        cached[key].default();
    });
});
